import { throttleErrorMessage } from '@hooks/use-throttled-mutation';
import { isRequestError } from '@utils/requests';

// A throttle rejection means an identical payload was submitted within the last
// second, so the earlier attempt owns the outcome and whatever it showed still
// stands. Returning a message here would either report a failure over a save
// that succeeded, or replace a real field error with a generic one.
export const getSlugSaveError = (error: unknown, fallbackMessage: string) => {
  if (error === throttleErrorMessage) {
    return undefined;
  }

  const slugErrors = isRequestError<{ slug?: string[] }>(error)
    ? error.response?.data?.slug
    : undefined;

  return slugErrors?.[0] || fallbackMessage;
};
